import { breakpoint } from '@carvana/helios-layout';
import { background, text } from '@carvana/helios-styles';
import { body, heading } from '@carvana/helios-typography';
import styled, { CSSProperties } from 'styled-components';

const ButtonContainer = styled.div`
  align-items: center;
  display: flex;
`;

const TradeInWrapper = styled.div`
  background: ${background.default};
  padding: 0px 24px 64px 24px;

  ${breakpoint.sm`
    padding: 0px 32px 80px 32px;
  `}

  ${breakpoint.md`
    padding: 0px 84px 80px 84px;
  `}
`;

const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 551px;
  margin: auto;

  ${breakpoint.sm`
    flex-direction: row;
    max-width: 959px;
  `}

  ${breakpoint.md`
    flex-direction: row;
    max-height: 368px;
    max-width: 1272px;
  `}
`;

const TextContainer = styled.div`
  background: ${background.strong};
  border-radius: 16px 16px 0px 0px;
  padding: 40px 10px;

  ${breakpoint.xs`
    padding: 40px 30px;
  `}

  ${breakpoint.sm`
    border-radius: 16px 0px 0px 16px;
    padding: 30px 32px;
    flex: 1;
  `}

  ${breakpoint.md`
    border-radius: 16px 0px 0px 16px;
    padding: 60px 84px;
  `}

  & a {
    text-decoration: none;

    &:hover {
      text-decoration: underline;
    }
  }
`;

const HeaderWrapper = styled.div`
  ${heading['2Xl']};
  color: ${text.inverse};

  ${breakpoint.md`
    ${heading['3Xl']};
  `}
`;

const TextWrapper = styled.div`
  ${body.lg};
  color: ${text.inverse};
  margin-top: 16px;
  margin-bottom: 32px;

  ${breakpoint.sm`
    ${body.md};
  `}

  ${breakpoint.md`
    ${body.lg};
  `}
`;

const ButtonWrapper = styled.div`
  margin-right: 40px;

  ${breakpoint.md`
    margin-right: 48px;
  `}
`;

const ImageWrapper = styled.div`
  position: relative;
  overflow: hidden;
  height: 218px;
  width: 100%;
  border-radius: 0px 0px 16px 16px;

  ${breakpoint.sm`
    height: initial;
    border-radius: 0px 16px 16px 0px;
    flex: 1;
  `}

  ${breakpoint.md`
    height: 368px;
    border-radius: 0px 16px 16px 0px;
  `}
`;

const ImageStyle: CSSProperties = {
  objectFit: 'cover',
  objectPosition: 'top'
};

export {
  ButtonContainer,
  ButtonWrapper,
  ContentWrapper,
  HeaderWrapper,
  ImageStyle,
  ImageWrapper,
  TextContainer,
  TextWrapper,
  TradeInWrapper
};
